import React from 'react';
import UploadComponent from './UploadComponent';

export function Upload({ handleUpload, setFolderUid, loading, multiple, size }: any) {
    return (
        <UploadComponent loading={loading} handleUpload={handleUpload} setFolderUid={setFolderUid} multiple={multiple} size={size} />
    )
}
